<div class="download-container">
    <img src="assets/images/logo/logo of sidc.png" class="logo" alt="Logo">
  
    <p class="label">E-Collect Mobile App</p>
  
    <button class="download-btn" (click)="downloadAndroidApk()">Download APK</button>
  </div>
  